import { Box } from '@rbilabs/universal-components';

export const LogoContainer = Box.withConfig({
  marginRight: '$0.5',
  justifyContent: 'center',
});
